// Binding handler om een aantal met een bepaald aantal decimalen (std. 2) op het scherm te tonen.
// Geef binding 'precisie' mee om af te wijken van het std. aantal van 2 decimalen.
// Geef binding 'decimalSeparator' mee om af te wijken van de '.'.s
export class AantalBindingHandler implements KnockoutBindingHandler {
    public init(element: Node, valueAccessor: () => any, allBindings: KnockoutAllBindingsAccessor) {
        let value = ko.unwrap(valueAccessor());
        if (value && typeof value === "number") {
            let precisie = allBindings.get('precisie') || 2;
            let strVal = value.toFixed(precisie);

            // Als een decimalen scheidingsteken is opgegeven, dan de punt vervangen door dat scheidingsteken
            let decSeparator = allBindings.get('decimalSeparator');
            if (decSeparator) {
                strVal = strVal.replace('.', decSeparator);
            }
            $(element).html(strVal);
        }
    }
}
